// extracted by css-extract-rspack-plugin
var _1 = "cj";
var _2 = "w4";
var _3 = "w2";
var _4 = "w3";
var _5 = "qu";
var _6 = "ut";
var _7 = "wc";
var _8 = "f2";
var _9 = "w7";
var _a = "ej";
var _b = "uu";
var _c = "w6";
var _d = "tu";
var _e = "w5";
export { _1 as "active", _2 as "buttonLightBlue", _3 as "buttonMagenta", _4 as "buttonMagentaRound", _5 as "buttonWrapper", _6 as "darkBlue", _7 as "lightBlue", _8 as "linkComponent", _9 as "linkContent", _a as "loadingComponent", _b as "magenta", _c as "rightArrow", _d as "standard", _e as "standardArrow" }
